import { SubVertical, subVerticalConfig, Vertical } from './verticalService'
import { isMobileEnv } from 'common/utils/common'
import { getSpecialEventTitle, SpecialEventType } from 'common/constants/specialEvent'

export const EVENT_LIST_DEFAULT_SIZE = 15
export const EVENT_LIST_SIZE = 10
export const EVENT_LIST_BRANCH_NEWS_SIZE = 5
export const EVENT_LIST_TRADITIONAL_ALCOHOL_SIZE = 3
export const RECOMMEND_EVENT_PC_SIZE = 12
export const RECOMMEND_EVENT_MOBILE_SIZE = 30
export const EVENT_LAYER_LIST_SIZE = 5

export const getEventPageSize = (subVertical: SubVertical) => {
  if (subVertical === SubVertical.DEPARTMENT || subVertical === SubVertical.OUTLET) return EVENT_LIST_SIZE
  if (subVertical === SubVertical.TRADITIONAL_ALCOHOL) return EVENT_LIST_TRADITIONAL_ALCOHOL_SIZE
  return EVENT_LIST_DEFAULT_SIZE
}

export const getNewsPageSizeAtEvent = (subVertical: SubVertical, specialEventType: SpecialEventType) => {
  if (usingNewsAtEvent(subVertical, specialEventType)) return EVENT_LIST_BRANCH_NEWS_SIZE
  return 0
}

export const usingNewsAtEvent = (subVertical: SubVertical, specialEventType: SpecialEventType) => {
  return (
    [SubVertical.DEPARTMENT, SubVertical.OUTLET, SubVertical.ART, SubVertical.TRADITIONAL_ALCOHOL].includes(
      subVertical,
    ) || isForeignEventPage(subVertical, specialEventType)
  )
}

export const getRecommendEventPageSize = () => {
  return isMobileEnv ? RECOMMEND_EVENT_MOBILE_SIZE : RECOMMEND_EVENT_PC_SIZE
}

export const getEventTitle = (subVertical: SubVertical, specialEventType?: SpecialEventType) => {
  if (subVerticalConfig[subVertical] && subVerticalConfig[subVertical].eventTitle) {
    return subVerticalConfig[subVertical].eventTitle
  }

  return specialEventType ? getSpecialEventTitle(specialEventType) : 'EVENT'
}

export const isShowTheme = (vertical: Vertical, subVertical?: SubVertical, specialEventType?: SpecialEventType) => {
  if (
    [Vertical.STYLE, Vertical.LIVING].includes(vertical) ||
    (vertical === Vertical.FOREIGN && specialEventType !== SpecialEventType.EXHIBITION) ||
    (subVertical && [SubVertical.HOME_MEAL, SubVertical.DIRECT_FARM, SubVertical.LOCAL_FOOD].includes(subVertical))
  ) {
    return false
  }
  return true
}

export const shownEventTitle = (subVertical: SubVertical, specialEventType?: SpecialEventType) => {
  if (
    [
      SubVertical.ART,
      SubVertical.HOME_MEAL,
      SubVertical.TRADITIONAL_ALCOHOL,
      SubVertical.DIRECT_FARM,
      SubVertical.LOCAL_FOOD,
    ].includes(subVertical) ||
    isForeignEventPage(subVertical, specialEventType)
  ) {
    return false
  }
  return true
}

export const isForeignEventPage = (subVertical: SubVertical, specialEventType: SpecialEventType) => {
  return subVertical === SubVertical.FOREIGN && specialEventType === SpecialEventType.EXHIBITION
}

// SpecialEventType별로 랜딩화면을 별도 페이지로 구성하는 케이스 구분
// 리빙(이벤트/플리마켓), 해외직구(이벤트/랭킹쇼핑/쇼핑꿀팁)
export const usingPageBySpecialEventType = (subVertical: SubVertical) => {
  return [SubVertical.HANDMADE, SubVertical.HOME_LIVING, SubVertical.STATIONERY, SubVertical.FOREIGN].includes(
    subVertical,
  )
}
